import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OpportunityService } from '@/services/opportunity.service';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import * as ReviewHistoryActions from './review-history.actions';

@Injectable()
export class ReviewHistoryEffects {
  private actions$ = inject(Actions);
  private opportunityService = inject(OpportunityService);

  loadReviewHistory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReviewHistoryActions.loadReviewHistory),
      switchMap(({ opportunityId, limit = 10 }) =>
        this.opportunityService.getReviewHistory(opportunityId, limit).pipe(
          map(reviewHistory =>
            ReviewHistoryActions.loadReviewHistorySuccess({ reviewHistory })
          ),
          catchError(error =>
            of(ReviewHistoryActions.loadReviewHistoryFailure({ error }))
          )
        )
      )
    )
  );

  refreshReviewHistory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReviewHistoryActions.refreshReviewHistory),
      switchMap(({ opportunityId, limit = 10 }) =>
        this.opportunityService.getReviewHistory(opportunityId, limit).pipe(
          map(reviewHistory =>
            ReviewHistoryActions.loadReviewHistorySuccess({ reviewHistory })
          ),
          catchError(error =>
            of(ReviewHistoryActions.loadReviewHistoryFailure({ error }))
          )
        )
      )
    )
  );
}